import { ArrowRight } from "lucide-react";
import Reveal from "../landing/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Solucion() {
  const { t } = useLanguage();

  return (
    <section id="solucion" className="bg-cream py-20 md:py-28" data-testid="solucion-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <p className="kicker" data-testid="solucion-kicker">{t.solucion.kicker}</p>
          <h2 className="mt-5 font-display text-3xl font-bold leading-tight text-forest-800 md:text-4xl lg:text-5xl">
            {t.solucion.title}
          </h2>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-forest-800/80">{t.solucion.lead}</p>
        </Reveal>

        <div className="mt-12" data-testid="solucion-services">
          {t.solucion.services.map((service, index) => (
            <Reveal key={service.name} delay={index * 0.08}>
              <div className="rule grid gap-4 py-8 md:grid-cols-[220px_1fr]" data-testid={`service-${service.name.toLowerCase()}`}>
                <div>
                  <h3 className="font-display text-2xl font-bold text-forest-800 md:text-3xl">{service.name}</h3>
                  <p className="mt-1 font-body text-[11px] font-bold uppercase tracking-[0.25em] text-ember">
                    {service.role}
                  </p>
                </div>
                <p className="max-w-3xl text-sm leading-relaxed text-forest-800/80 md:text-base">{service.desc}</p>
              </div>
            </Reveal>
          ))}
          <div className="rule" aria-hidden="true" />
        </div>

        <Reveal className="mt-10">
          <div className="bg-forest-800 p-8 md:p-10" data-testid="zerosight-box">
            <div className="grid items-center gap-6 md:grid-cols-[280px_1fr]">
              <h3 className="font-display text-2xl font-bold italic text-cream md:text-3xl">
                {t.solucion.zeroTitle}
              </h3>
              <p className="text-sm leading-relaxed text-cream/80 md:text-base">{t.solucion.zeroText}</p>
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-8">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-testid="solucion-chain">
            {t.solucion.chain.map((step, index) => (
              <span key={step} className="flex items-center gap-3">
                <span className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-forest-800">
                  {step}
                </span>
                {index < t.solucion.chain.length - 1 && <ArrowRight size={13} className="text-ember" />}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-14">
          <h3 className="font-display text-2xl font-bold text-forest-800" data-testid="notneeded-title">
            {t.solucion.notNeededTitle}
          </h3>
          <div className="mt-7 grid gap-8 md:grid-cols-3">
            {t.solucion.notNeeded.map((item) => (
              <div key={item.t} className="rule pt-5">
                <h4 className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-ember">{item.t}</h4>
                <p className="mt-3 text-sm leading-relaxed text-forest-800/75">{item.d}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
